import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M85.64 46.32L49.64 10.32C48.2 8.88 46.2 8 44 8H16C11.6 8 8 11.6 8 16V44C8 46.2 8.88 48.2 10.36 49.68L46.36 85.68C47.8 87.12 49.8 88 52 88C54.2 88 56.2 87.12 57.64 85.64L85.64 57.64C87.12 56.2 88 54.2 88 52C88 49.8 87.08 47.76 85.64 46.32ZM22 28C18.68 28 16 25.32 16 22C16 18.68 18.68 16 22 16C25.32 16 28 18.68 28 22C28 25.32 25.32 28 22 28Z",
  fill: "inherit"
}), 'Offers', {
  viewBox: '0 0 96 96'
});